import 'normalize.css/normalize.css';
import '../node_modules/@blueprintjs/icons/lib/css/blueprint-icons.css';
import '../node_modules/@blueprintjs/core/lib/css/blueprint.css';
import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import ArchDemo from './archdemo';
import './index.css';
import { FocusStyleManager } from "@blueprintjs/core";
 
FocusStyleManager.onlyShowFocusOnTabs();
document.body.classList.add("bp3-dark");

ReactDOM.render(
//  <React.StrictMode>
    <ArchDemo />
//  </React.StrictMode>
  ,
  document.getElementById('root')
);

serviceWorker.unregister();
